import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button"];

  connect() {
    this.isSubmitting = false;
  }

  handleSubmit(event) {
    // Prevent double submission
    if (this.isSubmitting) {
      event.preventDefault();
      return;
    }

    this.isSubmitting = true;

    if (this.hasButtonTarget) {
      // Replace with spinner (same size and color as delete icon)
      this.buttonTarget.innerHTML = `
        <svg class="animate-spin h-4 w-4 text-stone-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      `;

      // Disable button and set aria-busy for accessibility
      this.buttonTarget.disabled = true;
      this.buttonTarget.setAttribute("aria-busy", "true");
      this.buttonTarget.classList.add("opacity-50", "cursor-not-allowed");
    }
  }
}
